import Ball from "./models/ball";
import Cone from "./models/cone";
import Divider from "./models/dividerv2";
import Dribble from "./models/dribble";
import Goal from "./models/goal";
import Hotspot from "./models/hotspot";
import Indicator from "./models/indicator";
import Movement from "./models/movement";
import Pass from "./models/pass";
import PhysicalActivityArea from "./models/physical_activity_area";
import Player from "./models/player";
import PlayerWithBall from "./models/player_with_ball";
import Press from "./models/press";
import Transition from "./models/transition";

const classMap = { Ball, Cone, Divider, Dribble, Goal, Hotspot, Indicator, Movement, Pass, PhysicalActivityArea, Player, PlayerWithBall, Press, Transition }


export const instantiateModel = (data, context) => {
  const className = data.type.replace(/^(.)|\_(\w)/g, (match, p1, p2) => {
    if (p2) return p2.toUpperCase();
    return p1.toUpperCase();
  });

  const object = new classMap[className]({ ...data, context });

  return object;
}
